import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import InstagramStory from 'dyzio-shared-components/lib/components/instagram-story';
import { Loader, Button, Popup, Divider } from 'semantic-ui-react';
import hasRESTClient from '../../hocs/has-rest-client';

class InstagramStoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      story: null,
    };
  }

  componentWillMount() {
    const { restClient, selectedStory } = this.props;
    restClient.get(`stories/${selectedStory}`).then(response => {
      const { data: { data } } = response;
      this.setState({
        story: data.attributes,
        isLoading: false,
      });
    }).catch(() => this.setState({
      isLoading: false,
    }));
  }

  render() {
    const { isLoading, story } = this.state;
    const { campaignHashtags, selectedStory, campaignName, onClose, inDeleteMode, onDeleteAssetCallback } = this.props;
    const campaign = { name: campaignName };
    return (
      <DyzioModal
        onClose={onClose}
        headerText="Story"
      >
        {
          isLoading && <Loader active inverted />
        }
        {
          !isLoading &&
            <div>
              <InstagramStory
                campaign={campaign}
                shouldHighlight
                campaignHashtags={_.map(_.split(campaignHashtags || '', ','), _.trim)}
                fluid
                {...story}
              />
              {
                inDeleteMode &&
                <Popup
                  position="bottom center"
                  content={
                    <div style={{ width: 200, textAlign: 'center' }}>
                      <h2>Are you sure?</h2>
                      <Divider />
                      <Button.Group fluid>
                        <Button size="big" onClick={() => onDeleteAssetCallback(selectedStory)} color="green">Yes</Button>
                        <Button size="big" onClick={onClose}>No</Button>
                      </Button.Group>
                    </div>
                  }
                  on="click"
                  trigger={
                    <Button
                      inverted
                      fluid
                      color="red"
                      icon="warning"
                      content="Remove story"
                    />
                  }
                />
              }
            </div>
        }
      </DyzioModal>
    );
  }
}

InstagramStoryModal.propTypes = {
  selectedStory: PropTypes.string.isRequired,
  campaignName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  restClient: PropTypes.func.isRequired,
  inDeleteMode: PropTypes.bool,
  onDeleteAssetCallback: PropTypes.func,
};

InstagramStoryModal.defaultProps = {
  inDeleteMode: false,
  onDeleteAssetCallback: _.noop,
};

export default compose(
  hasRESTClient,
)(InstagramStoryModal);



/** WEBPACK FOOTER **
 ** ./src/containers/instagram-story-modal/index.js
 **/